var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotiActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427322473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5 9.5C18.5 5.1 14 3.5 12 3.5C9.79584 3.5 5.70414 5.1 5.70414 9.5V12.5C5.70414 13.3333 5.70414 15 3.70414 16.5C3.27226 16.8239 3.03096 17.2799 3.00279 17.9563C2.96459 18.8732 3.84796 19.5 4.7657 19.5H20.5C20.7938 19.5 21.0535 19.3 21.1079 19.0112C21.3517 17.7171 21.1262 16.9697 20.5 16.5C18.5 15 18.5 13.3333 18.5 12.5V9.5Z",
    fill: "url(#paint0_linear_103_12430)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.5 9.5C18.5 5.1 14 3.5 12 3.5C9.79584 3.5 5.70414 5.1 5.70414 9.5V12.5C5.70414 13.3333 5.70414 15 3.70414 16.5C3.06077 16.9825 2.84034 17.7582 3.11736 19.1189C3.16314 19.3437 3.3651 19.5 3.59453 19.5H20.5H20.6096C20.839 19.5 21.041 19.3437 21.0868 19.1189C21.3638 17.7582 21.1434 16.9825 20.5 16.5C18.5 15 18.5 13.3333 18.5 12.5V9.5Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 18",
    d: "M12 2V3.5",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 292045",
    d: "M15 19.5C15 21.1569 13.6569 22.5 12 22.5C10.3431 22.5 9 21.1569 9 19.5",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_12430",
    x1: 3.50567,
    y1: 19.5,
    x2: 17.1461,
    y2: 3.73852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiActive);
export default __webpack_public_path__ + "static/media/noti-active.af62e14be97a013f1d7430e6bc4147c1.svg";
export { ForwardRef as ReactComponent };